import { writable } from "svelte/store";

import type { Signature } from "./types.ts";

const signatures = new Map<string, Signature>();
const pending = new Set<string>();

export const signatureStore = writable(signatures);

export const getSignature = (uuid: string): Signature | null => {
  return signatures.get(uuid) || null;
};

export const storeSignature = (signature: Signature): void => {
  signatures.set(signature.uuid, signature);
  pending.delete(signature.uuid);
  signatureStore.set(signatures);
  console.log(`[SIGNATURE] Stored signature: ${signature.name} (${signature.uuid})`);
};

export const requestSignature = (uuid: string, requestFn: (uuid: string) => void): void => {
  if (signatures.has(uuid) || pending.has(uuid)) return;

  pending.add(uuid);
  console.log(`[SIGNATURE] Requesting signature: ${uuid}`);
  requestFn(uuid);
};

export const getSignatureDisplay = (uuid: string): { name: string; avatar_url: string } => {
  const signature = signatures.get(uuid);
  if (signature) {
    return { name: signature.name, avatar_url: signature.avatar_url };
  }
  console.log(`[SIGNATURE] Fallback for signature: ${uuid}`);
  return { name: `#${uuid.slice(0, 8)}`, avatar_url: "/favicon.png" };
};
